/** Build-time feature switches (09 P5.12). */
export const FEATURES = {
  /** Table3D (P5.12): `auto` picks it where WebGL2 is available; the "Table view" choice shows. */
  table3d: true,
  /** `/leaderboard` and its links (P8.8), on since P8.13. */
  leaderboard: true,
  /** tile.game's game routes (11 §8.6), on since P15 ships local dominoes. */
  tileSite: true,
  /** Dominoes on tile.game (11 §8.6): local play in P15, online from P16. */
  dominoes: true,
  /** Triominoes on tile.game (11 §8.6): local play and online tables from P17. */
  triominoes: true,
  /** Mexican Train on tile.game (11 §8.6): local play and online tables from P18. */
  mexicanTrain: true,
  /** Quadominoes on tile.game (11 §8.6, ADR 0074): local play and online tables from P22; hidden until it is done. */
  quadominoes: true,
  /** Hexominoes on tile.game (11 §8.6, ADR 0074): local play and online tables from P23. */
  hexominoes: true,
  /**
   * Spherominoes on tile.game (11 §8.6, ADR 0077): local play and online tables from P24, the ball drawn with three.js;
   * hidden until it is done.
   */
  spherominoes: true,
  /**
   * Tile Rummy on tile.game (23, ADR 0082): local play and online tables from P28, the melds table drawn by its own
   * page; on the `tile-rummy` branch until Alexander merges it.
   */
  tileRummy: true,
} as const;
